import styled from 'styled-components';

import { TableContainer } from 'components/DefaultTable/styles';
import colors from 'themes/Main';

const {
  gray01,
  gray03,
  warning,
  danger,
  pink,
  success,
  white,
  darkBlue,
} = colors;

export const TopInfo = styled.div`
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 64px;
  margin-top: -32px;
`;

export const Cards = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const LineFlex = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  margin: -32px 0 32px;
`;

export const Table = styled(TableContainer)`
  tbody tr td {
    font-size: 14px;
  }

  tbody tr td:nth-child(2) {
    width: 300px;
  }

  tbody tr {
    cursor: default;
  }

  tr td:last-child {
    font-weight: 700;
  }

  tr th {
    vertical-align: middle;
  }

  thead tr th:first-child,
  tbody tr td:first-child {
    padding-top: 22px;
  }

  th,
  td {
    padding: 15px;
  }

  thead tr th:nth-child(4),
  thead tr th:nth-child(5),
  tbody tr td:nth-child(4),
  tbody tr td:nth-child(5) {
    text-align: center;
  }

  .status- {
    color: ${gray01};
  }

  .status-not-pointed {
    color: ${warning};
  }

  .status-refused,
  .status-refused > span {
    color: ${danger};
  }

  .status-pending,
  .status-pending > span {
    color: ${pink};
  }

  .status-approved,
  .status-approved > span {
    color: ${success};
  }
`;

export const ExtraHourInfos = styled.div`
  display: inline-block;
  margin-left: 4px;
  position: relative;
`;

export const ExtraHourInfosIcon = styled.div`
  cursor: pointer;

  &:hover + div {
    display: block;
  }
`;

export const ExtraHourInfosContent = styled.div`
  z-index: 5;
  position: absolute;
  bottom: -50px;
  right: 25px;
  display: none;
  width: 250px;
  padding: 16px;
  min-height: 80px;
  height: auto;
  background-color: ${white};
  border-radius: 4px;
  border: 1px solid rgba(215, 220, 230, 0.4);
  box-shadow: 0px 7px 8px rgba(215, 220, 230, 0.2),
    0px 5px 22px rgba(215, 220, 230, 0.12),
    0px 12px 17px rgba(215, 220, 230, 0.14);

  p {
    text-align: left;
    margin-bottom: 8px;

    span {
      font-weight: 700;
      color: ${darkBlue};
    }
  }
`;

export const Callback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 64px;
`;

export const CallbackText = styled.h2`
  width: 500px;
  margin-top: 32px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${gray03};
  text-align: center;

  p {
    display: block;
    margin-bottom: 8px;
  }
`;
